
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/how-we-work",
      function () {
        return require("private-next-pages/severalbrands/how-we-work.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/how-we-work"])
      });
    }
  